import { useApi } from './useApi';
import { useAppState } from './useAppState';
import { getHttpInstance, getApiConfig } from './useApi';
export function useCredit() {
    const api = useApi();
    const state = useAppState();
    function getCreditInfo(onSuccess = null, refreshCache = false) {
        api.GET("/Customers/00000000-0000-0000-0000-000000000000/CreditAccounts", (result) => {
            state.creditInfo = result;
            if (onSuccess)
                onSuccess(result);
        }, !refreshCache, refreshCache);
    }
    function getCreditProviders(onSuccess = null) {
        api.GET("/CreditProviders", (result) => {
            state.creditProviders = result;
            if (onSuccess)
                onSuccess(result);
        }, true);
    }
    function getCreditTypes(onSuccess = null) {
        api.GET("/CreditTypes", (result) => {
            state.creditTypes = result;
            if (onSuccess)
                onSuccess(result);
        }, true);
    }
    function getCreditAccount(id, onSuccess = null, refreshCache = false) {
        api.GET("/Customers/00000000-0000-0000-0000-000000000000/CreditAccounts/" + id, (result) => {
            state.creditAccount = result;
            if (onSuccess)
                onSuccess(result);
        }, !refreshCache, refreshCache);
    }
    function addCreditAccount(credit, onSuccess = null) {
        getHttpInstance().post(getApiConfig().api + "/Customers/00000000-0000-0000-0000-000000000000/CreditAccounts", credit)
            .then((response) => { if (onSuccess)
            onSuccess(response.data); })
            .catch((result) => {
            if (result.response && result.response.status == 401) {
                api.refreshLogin(() => addCreditAccount(credit, onSuccess));
            }
        });
    }
    function updateCreditAccount(credit, onSuccess = null) {
        getHttpInstance().put(getApiConfig().api + "/Customers/00000000-0000-0000-0000-000000000000/CreditAccounts/" + credit.id, credit)
            .then((response) => { if (onSuccess)
            onSuccess(response.data); })
            .catch((result) => {
            if (result.response && result.response.status == 401) {
                api.refreshLogin(() => updateCreditAccount(credit, onSuccess));
            }
        });
    }
    function deleteCreditAccount(id, onSuccess = null) {
        getHttpInstance().delete(getApiConfig().api + "/Customers/00000000-0000-0000-0000-000000000000/CreditAccounts/" + id)
            .then((response) => { if (onSuccess)
            onSuccess(response.data); })
            .catch((result) => {
            if (result.response && result.response.status == 401) {
                api.refreshLogin(() => deleteCreditAccount(id, onSuccess));
            }
        });
    }
    return {
        getCreditInfo,
        getCreditProviders,
        getCreditTypes,
        getCreditAccount,
        addCreditAccount,
        updateCreditAccount,
        deleteCreditAccount,
    };
}
